<template id="ingreso-preguntas-simce-page">
  <div class="is-100-vw simce-page">
    <div class="container mt-4">
      <div class="simce-filters box">
        <h1 class="simce-page-title">Ingreso masivo · Preguntas SIMCE</h1>
        <p class="simce-page-subtitle">Selecciona curso y asignatura SIMCE; luego carga el Excel por capítulo.</p>
        <div class="columns is-multiline">
          <div class="column is-12-tablet is-6-desktop">
            <CursoDropdown 
              v-model="selectedCurso" 
              :mostrarErrores="mostrarErrores" 
              tooltip="Selecciona un curso" 
              @update:modelValue="onCursoChange"
            />
          </div>
          <div class="column is-12-tablet is-6-desktop">
            <AsignaturaDropdown 
              v-model="selectedAsignatura" 
              glosa-contiene="simce"
              :mostrarErrores="mostrarErrores" 
              tooltip="Selecciona una asignatura SIMCE" 
              @update:modelValue="onAsignaturaChange"
            />
          </div>
        </div>
      </div>

      <div v-if="current_capitulo" class="simce-toolbar-title has-text-success">
        {{ current_capitulo }}
      </div>

    </div>

    <!-- Iterar sobre las unidades (carrusel horizontal por capítulo se mantiene) -->
    <div v-for="unit in orderedGroupedChapters" :key="unit.unidad" class="container simce-unit-wrap">
      <div class="unit-border simce-unit-card">
        <div class="simce-unit-header">
          <p class="simce-unit-meta">{{ unit.grupos.length }} grupos</p>
        </div>

        <div v-for="grupo in unit.grupos" :key="grupo.grupo" class="simce-grupo-block">
          <div class="simce-grupo-label">
            <span class="simce-grupo-tag">Capítulo</span>
            <span class="simce-grupo-name">{{ grupo.grupo }}</span>
          </div>

          <div class="columns ml-0 is-mobile is-gapless columns-horizontal-scroll simce-chapter-scroll">
            <div
              v-for="cap in grupo.capitulos"
              :key="cap.IdCapitulo"
              class="card video-card simce-chapter-card"
            >
              <div class="simce-chapter-head">
                <span class="simce-badge-orden">Ord. {{ cap.Orden }}</span>
                <span class="simce-id-chip" title="Id capítulo">{{ cap.IdCapitulo }}</span>
                <h3 class="simce-chapter-glosa">{{ cap.Glosa }}</h3>
              </div>
              <div class="columns is-mobile is-gapless video-carousel simce-video-carousel">
                <div v-for="(v, idx) in getVideosCap(cap.IdCapitulo)" :key="idx" class="column video-card-column simce-video-column">
                  <div class="simce-video-tile">
                    <div class="simce-video-meta">
                      <span class="simce-meta-item"><strong>ID</strong> {{ v.IdVideo }}</span>
                      <span class="simce-meta-sep">·</span>
                      <span class="simce-meta-item"><strong>Vimeo</strong> {{ v.VimeoId != null && v.VimeoId !== '' ? v.VimeoId : '—' }}</span>
                    </div>
                    <p class="simce-video-title" :title="v.Glosa">{{ v.Glosa }}</p>

                    <div class="simce-video-actions">
                      <ButtonPrime 
                        label="Cargar Excel SIMCE" 
                        icon="pi pi-upload" 
                        class="p-button-success p-button-sm w-full" 
                        @click="openQuestionModal(v)" 
                      />
                      <MatrixUploaderSimce
                        :id-curso="selectedCurso[0]"
                        :id-asignatura="selectedAsignatura[0]"
                        :id-unidad="mapUnidad(cap.UnidadGrupo)"
                        :id-capitulo="cap.IdCapitulo"
                        :id-video="v.IdVideo"
                        :usuario-id="user"
                        @matrix-simce-pregunta-loaded="onMatrixSimceOk"
                        @matrix-simce-pregunta-error="onMatrixSimceErr"
                        @matrix-simce-practica-loaded="onMatrixSimceOk"
                        @matrix-simce-practica-error="onMatrixSimceErr"
                      />
                      <PreguntasPorUnidadYCapituloDialog
                        :id-eje-tematico="mapUnidad(cap.UnidadGrupo)"
                        :id-capitulo="cap.IdCapitulo"
                        :id-video="v.IdVideo"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- DialogPrime para carga masiva de preguntas -->
    <DialogPrime
      :visible="showQuestionModal"
      @update:visible="showQuestionModal = $event"
      header="Cargar Preguntas SIMCE"
      :modal="true"
      :style="{ width: '80vw' }"
    >
      <div class="p-d-flex p-flex-column p-ai-center">
        <h3 class="p-mb-3">{{ selectedVideo?.Glosa }}</h3>
        <div class="p-mb-4 upload-section">
          <label class="file-label p-d-inline-block p-p-3 p-text-center">
            <span class="simce-upload-hint">
              Excel SIMCE: hojas <strong>preguntas</strong> y <strong>alternativas</strong>.
              En <strong>preguntas</strong>, columna <strong>M · TEXTO</strong> = descripción de la imagen (accesibilidad).
            </span>
            <input type="file" @change="handleFileUpload" accept=".xlsx, .xls" class="file-input" />
          </label>
        </div>

        <div v-if="excelData.length" class="table-container p-w-100">
          <DataTablePrime 
            :value="excelData" 
            :paginator="true" 
            :rows="10" 
            :rowsPerPageOptions="[5, 10, 20]" 
            responsiveLayout="scroll"
            class="p-datatable-sm"
            dataKey="_rowUid"
          >
            <ColumnPrime header="Acción" headerStyle="width: 8rem">
              <template #body="slotProps">
                <ButtonPrime 
                  v-if="!isRowSelected(slotProps.data)" 
                  label="Agregar" 
                  icon="pi pi-plus" 
                  class="p-button-sm p-button-success" 
                  @click="addRow(slotProps.data)" 
                  :disabled="slotProps.data.status === 'Procesando' || isProcessing"
                />
                <ButtonPrime 
                  v-else 
                  label="Quitar" 
                  icon="pi pi-minus" 
                  class="p-button-sm p-button-danger" 
                  @click="removeRow(slotProps.data)" 
                  :disabled="slotProps.data.status === 'Procesando' || isProcessing"
                />
              </template>
            </ColumnPrime>

            <ColumnPrime header="N° PREGUNTA">
              <template #body="slotProps">
                {{ numeroPreguntaDisplay(slotProps.data.pregunta) }}
              </template>
            </ColumnPrime>

            <ColumnPrime header="PREGUNTA">
              <template #body="slotProps">
                {{ slotProps.data.pregunta['PREGUNTA'] }}
              </template>
            </ColumnPrime>

            <ColumnPrime header="ALTERNATIVAS">
              <template #body="slotProps">
                {{ slotProps.data.alternativas.map(a => `${numeroAlternativaValue(a)}: ${glosaAlternativa(a)} (${esAlternativaCorrecta(a) ? 'Correcta' : 'Incorrecta'})`).join(', ') }}
              </template>
            </ColumnPrime>

            <ColumnPrime header="GRADO DE DIFICULTAD">
              <template #body="slotProps">
                {{ dificultadExcelDisplay(slotProps.data.pregunta) }}
              </template>
            </ColumnPrime>

            <ColumnPrime header="HABILIDAD">
              <template #body="slotProps">
                {{ habilidadExcelDisplay(slotProps.data.pregunta) }}
              </template>
            </ColumnPrime>

            <ColumnPrime header="UNIDAD">
              <template #body="slotProps">
                {{ slotProps.data.pregunta['UNIDAD'] }}
              </template>
            </ColumnPrime>

            <ColumnPrime header="SOLUCIÓN DESCRIPTIVA">
              <template #body="slotProps">
                {{ slotProps.data.pregunta['SOLUCIÓN_DESCRIPTIVA'] }}
              </template>
            </ColumnPrime>

            <ColumnPrime header="IMAGEN DE PREGUNTA">
              <template #body="slotProps">
                {{ slotProps.data.pregunta['IMAGEN_DE_PREGUNTA'] }}
              </template>
            </ColumnPrime>

            <ColumnPrime header="TEXTO (col. M)" :style="{ minWidth: '12rem' }">
              <template #body="slotProps">
                <span class="simce-cell-texto">{{ descripcionImagenFromRow(slotProps.data.pregunta) || '—' }}</span>
              </template>
            </ColumnPrime>

            <ColumnPrime header="Estado">
              <template #body="slotProps">
                <span 
                  :class="getStatusClass(slotProps.data.status)" 
                  @click="handleStatusClick(slotProps.data)"
                  style="cursor: pointer;"
                >
                  {{ slotProps.data.status || 'Pendiente' }}
                  <i v-if="slotProps.data.status === 'Procesando'" class="pi pi-spin pi-spinner" style="margin-left: 5px;"></i>
                  <i v-else-if="slotProps.data.status === 'Éxito'" class="pi pi-check" style="margin-left: 5px;"></i>
                  <i v-else-if="slotProps.data.status && slotProps.data.status.startsWith('Error')" class="pi pi-times" style="margin-left: 5px;"></i>
                </span>
              </template>
            </ColumnPrime>

            <ColumnPrime header="Imagen" headerStyle="width: 9rem">
              <template #body="slotProps">
                <ButtonPrime
                  v-if="slotProps.data.status === 'Éxito' && slotProps.data.idPreguntaBd"
                  label="Subir imagen"
                  icon="pi pi-image"
                  class="p-button-sm p-button-secondary"
                  @click="openExcelUploadImageModal(slotProps.data)"
                />
                <span v-else-if="slotProps.data.status === 'Éxito'" class="is-size-7 has-text-grey">Sin id BD</span>
                <span v-else class="is-size-7 has-text-grey">—</span>
              </template>
            </ColumnPrime>
          </DataTablePrime>
        </div>
      </div>

      <template #footer>
        <div class="p-d-flex p-jc-end p-gap-2">
          <ButtonPrime 
            label="Agregar Todas" 
            icon="pi pi-plus-circle" 
            class="p-button-info" 
            @click="addAllRows" 
            :disabled="isProcessing || excelData.length === selectedRows.length"
          />
          <ButtonPrime 
            label="Eliminar Todas" 
            icon="pi pi-minus-circle" 
            class="p-button-warning" 
            @click="removeAllRows" 
            :disabled="isProcessing || !selectedRows.length"
          />
          <ButtonPrime 
            label="Cargar Preguntas SIMCE" 
            icon="pi pi-check" 
            class="p-button-success" 
            @click="guardarPreguntas" 
            :disabled="!selectedRows.length || isProcessing" 
            :loading="isProcessing"
          />
          <ButtonPrime 
            label="Cancelar" 
            icon="pi pi-times" 
            class="p-button-secondary" 
            @click="closeQuestionModal" 
            :disabled="isProcessing"
          />
        </div>
      </template>
    </DialogPrime>

    <!-- Diálogo para mostrar el log -->
    <DialogPrime
      :visible="showLogModal"
      @update:visible="showLogModal = $event"
      header="Log de la Pregunta"
      :modal="true"
      :style="{ width: '50vw' }"
    >
      <div v-if="selectedQuestionLog" class="p-d-flex p-flex-column">
        <h4>Pregunta: {{ selectedQuestionLog.pregunta['PREGUNTA'] }}</h4>
        <p><strong>N° de Pregunta:</strong> {{ numeroPreguntaDisplay(selectedQuestionLog.pregunta) }}</p>
        <p><strong>Log:</strong></p>
        <pre>{{ selectedQuestionLog.log || 'No hay log disponible.' }}</pre>
      </div>
      <template #footer>
        <ButtonPrime 
          label="Cerrar" 
          icon="pi pi-times" 
          class="p-button-secondary" 
          @click="showLogModal = false"
        />
      </template>
    </DialogPrime>

    <!-- Subir imagen por fila del Excel (tras guardar con éxito; id BD viene del API) -->
    <DialogPrime
      :visible="showExcelUploadImageModal"
      @update:visible="showExcelUploadImageModal = $event"
      header="Subir imagen de pregunta"
      :modal="true"
      :style="{ width: 'min(32rem, 95vw)' }"
    >
      <div v-if="excelUploadRow && selectedVideo" class="simce-upload-img-dialog">
        <p class="simce-upload-img-hint">
          Capítulo <strong>{{ selectedVideo.IdCapitulo }}</strong> · Video <strong>{{ selectedVideo.IdVideo }}</strong>
        </p>
        <p class="simce-upload-img-hint is-muted">
          N° Excel: <strong>{{ numeroPreguntaDisplay(excelUploadRow.pregunta) }}</strong> · ID pregunta (BD):
          <strong>{{ excelUploadRow.idPreguntaBd }}</strong>
        </p>
        <SubirImagen
          :key="excelUploadRow._rowUid"
          :id-pregunta="excelUploadRow.idPreguntaBd"
          :id-video="selectedVideo.IdVideo"
          :id-capitulo="selectedVideo.IdCapitulo"
          @image-uploaded="onExcelUploadImageUploaded"
          @upload-error="onSimceImageUploadError"
        />
      </div>
      <template #footer>
        <ButtonPrime
          label="Cerrar"
          icon="pi pi-times"
          class="p-button-secondary"
          @click="closeExcelUploadImageModal"
        />
      </template>
    </DialogPrime>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PreguntaService from '@/services/PreguntaService';
import HabilidadService from '@/services/HabilidadService';
import DificultadService from '@/services/DificultadService';
import {
  buildIdGlosaMap,
  DIFICULTAD_LABELS_FALLBACK,
  HABILIDAD_LABELS_FALLBACK,
  resolveCatalogDisplay,
} from '@/utils/preguntaCatalogLabels';
import SobjectService from '@/services/SobjectService';
import CursoDropdown from '@/components/selectores/CursoDropdown.vue';
import AsignaturaDropdown from '@/components/selectores/AsignaturaDropdown.vue';
import * as XLSX from 'xlsx';
import DialogPrime from 'primevue/dialog';
import DataTablePrime from 'primevue/datatable';
import ColumnPrime from 'primevue/column';
import ButtonPrime from 'primevue/button';
import PreguntasPorUnidadYCapituloDialog from '@/components/pregunta/PreguntasPorUnidadYCapituloDialog.vue';
import MatrixUploaderSimce from '@/components/pregunta/MatrixUploaderSimce.vue';
import SubirImagen from '@/components/SubirImagen.vue';

export default {
  name: 'ingreso-preguntas-simce-page',
  components: {
    CursoDropdown,
    AsignaturaDropdown,
    DialogPrime,
    DataTablePrime,
    ColumnPrime,
    ButtonPrime,
    PreguntasPorUnidadYCapituloDialog,
    MatrixUploaderSimce,
    SubirImagen
  },
  data() {
    return {
      showPreguntasDialog: false,
      selectedEjeTematico: 0,
      selectedCapitulo: 0,
      subject: null,
      chapters: [],
      isLoaded: false,
      orderedGroupedChapters: [],
      selectedCurso: [],
      selectedAsignatura: [],
      mostrarErrores: false,
      showQuestionModal: false,
      selectedVideo: null,
      excelData: [],
      tableHeaders: [
        'N°_PREGUNTA', 'PREGUNTA', 'ALTERNATIVAS', 'GRADO_DE_DIFICULTAD', 'HABILIDAD', 'UNIDAD', 'SOLUCIÓN_DESCRIPTIVA', 'IMAGEN_DE_PREGUNTA', 'TEXTO'
      ],
      selectedUnidadId: 0,
      selectedRows: [],
      isProcessing: false,
      allSelected: false,
      showLogModal: false,
      selectedQuestionLog: null,
      showExcelUploadImageModal: false,
      excelUploadRow: null,
      habilidadesCatalog: [],
      habilidadesByKey: {},
      habilidadesById: {},
      dificultadesById: {},
      device: {
        isMobile: false,
        isTablet: false,
        isTabletOnly: false,
        isDesktop: false,
        isDesktopOnly: false,
        isWidescreen: false,
        isWidescreenOnly: false,
        isFullhd: false,
      }
    };
  },
  methods: {
    openPreguntasDialog(cap) {
      this.selectedEjeTematico = this.mapUnidad(cap.UnidadGrupo);
      this.selectedCapitulo = cap.IdCapitulo;
      this.showPreguntasDialog = true;
    },
    getVideosCap(idd) {
      return this.subject?.VideosCapitulo.filter(x => x.IdCapitulo === idd) || [];
    },
    goVideo(video, capitulo) {
      console.log('Navegando a video:', video);
      capitulo.videos_capitulo__ = this.getVideosCap(capitulo.IdCapitulo);
      this.$store.dispatch('auth/set-current-capitulo', capitulo);
      this.$store.dispatch('auth/set-current-capitulo-id', capitulo.IdCapitulo);

      const vmi = video.VimeoId || 0;
      this.$router.push({
        name: 'watch-video',
        params: {
          video_glosa: video.Glosa,
          video_url: video.Link,
          video_id: video.IdVideo,
          video_poster: video.LinkImgPortada,
          vimeo_id: vmi,
          asignatura_id: this.selectedAsignatura[0],
          curso_id: this.selectedCurso[0]
        }
      });
    },
    getChapters(id_curso, id_asignatura) {
      console.log('Obteniendo capítulos para curso:', id_curso, 'y asignatura:', id_asignatura);
      this.$store.dispatch('form/submit', true);
      SobjectService.getDataSubjects(id_curso, id_asignatura)
        .then(response => {
          console.log('Respuesta de capítulos:', response.data);
          this.subject = response.data;
          const groupedByUnit = this.subject.Capitulos.reduce((units, chapter) => {
            const unitKey = chapter.UnidadGrupo;
            if (!units[unitKey]) units[unitKey] = {};
            const groupKey = chapter.GlosaGrupo;
            if (!units[unitKey][groupKey]) units[unitKey][groupKey] = [];
            units[unitKey][groupKey].push(chapter);
            return units;
          }, {});

          Object.keys(groupedByUnit).forEach(unitKey => {
            Object.keys(groupedByUnit[unitKey]).forEach(groupKey => {
              groupedByUnit[unitKey][groupKey].sort((a, b) => a.Orden - b.Orden);
            });
          });

          this.orderedGroupedChapters = Object.entries(groupedByUnit).map(([unidad, grupos]) => ({
            unidad,
            grupos: Object.entries(grupos).map(([grupo, capitulos]) => ({ grupo, capitulos }))
          }));
          console.log('Capítulos organizados:', this.orderedGroupedChapters);
          this.$store.dispatch('form/submit', false);
        })
        .catch(error => {
          console.error('Error al obtener los capítulos:', error);
          this.$store.dispatch('form/submit', false);
        });
    },
    onCursoChange(newValue) {
      console.log('Curso seleccionado:', newValue);
      this.selectedCurso = newValue;
      if (this.selectedCurso.length && this.selectedAsignatura.length) {
        this.getChapters(this.selectedCurso[0], this.selectedAsignatura[0]);
      }
    },
    onAsignaturaChange(newValue) {
      console.log('Asignatura seleccionada:', newValue);
      this.selectedAsignatura = newValue;
      if (this.selectedCurso.length && this.selectedAsignatura.length) {
        this.getChapters(this.selectedCurso[0], this.selectedAsignatura[0]);
      }
    },

    openQuestionModal(video) {
      console.log('Abriendo modal para video:', video);
      this.selectedVideo = video;
      this.showQuestionModal = true;
      this.excelData = [];
      this.selectedRows = [];
      this.isProcessing = false;
      this.loadCatalogos();

      const capitulo = this.subject.Capitulos.find(c => c.IdCapitulo === video.IdCapitulo);
      if (capitulo) {
        this.selectedUnidadId = capitulo.UnidadId || 0;
      } else {
        console.error('No se encontró el capítulo para el video:', video.IdCapitulo);
        this.selectedUnidadId = 0;
      }
    },
    closeQuestionModal() {
      console.log('Cerrando modal');
      this.showQuestionModal = false;
      this.selectedVideo = null;
      this.selectedRows = [];
      this.isProcessing = false;
      this.closeExcelUploadImageModal();
    },
    findSheetWorkbook(workbook, wanted) {
      const w = wanted.toLowerCase();
      const name = workbook.SheetNames.find(s => String(s).trim().toLowerCase() === w);
      return name ? workbook.Sheets[name] : null;
    },

    transformExcelRow(row) {
      const transformedRow = {};
      const originalKeys = Object.keys(row);
      originalKeys.forEach((key) => {
        const newKey = String(key).trim().replace(/\s+/g, '_');
        transformedRow[newKey] = row[key];
      });
      const hasTexto = originalKeys.some((k) => String(k).trim().toLowerCase() === 'texto');
      const hasDescCol = originalKeys.some((k) => /descrip/i.test(String(k).trim()));
      if (!hasTexto && !hasDescCol && originalKeys.length > 0) {
        const lastKey = String(originalKeys[originalKeys.length - 1]).trim().replace(/\s+/g, '_');
        transformedRow.DESCRIPCIÓN_DE_LA_IMAGEN = transformedRow[lastKey] ?? '';
      }
      let numeroPregunta = '';
      for (const k of Object.keys(transformedRow)) {
        const compact = String(k).toLowerCase().replace(/_/g, '');
        if (
          compact === 'n°depregunta' ||
          compact === 'nºdepregunta' ||
          compact === 'ndepregunta' ||
          /^n[°º]depregunta$/.test(compact)
        ) {
          numeroPregunta = transformedRow[k];
          break;
        }
      }
      transformedRow.__numeroPreguntaSimce = numeroPregunta;
      return transformedRow;
    },

    /** Número de pregunta: encabezados "N° DE PREGUNTA", "Nº DE PREGUNTA", etc. */
    numeroPreguntaValue(obj) {
      if (!obj || typeof obj !== 'object') return '';
      if (
        obj.__numeroPreguntaSimce !== undefined &&
        obj.__numeroPreguntaSimce !== null &&
        String(obj.__numeroPreguntaSimce).trim() !== ''
      ) {
        return obj.__numeroPreguntaSimce;
      }
      const direct = ['N°_DE_PREGUNTA', 'Nº_DE_PREGUNTA', 'N_DE_PREGUNTA'];
      for (const k of direct) {
        const v = obj[k];
        if (v !== undefined && v !== null && String(v).trim() !== '') return v;
      }
      return '';
    },

    numeroPreguntaDisplay(pregunta) {
      const v = this.numeroPreguntaValue(pregunta);
      return v === '' || v === undefined || v === null ? '—' : v;
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) {
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });

          if (workbook.SheetNames.length < 2) {
            alert('El Excel debe tener dos hojas: "preguntas" y "alternativas".');
            return;
          }

          const preguntasSheet =
            this.findSheetWorkbook(workbook, 'preguntas') || workbook.Sheets[workbook.SheetNames[0]];
          const alternativasSheet =
            this.findSheetWorkbook(workbook, 'alternativas') || workbook.Sheets[workbook.SheetNames[1]];

          if (!preguntasSheet || !alternativasSheet) {
            alert('No se encontraron las hojas "preguntas" y "alternativas" (el nombre puede ir en minúsculas).');
            return;
          }

          const preguntasDataRaw = XLSX.utils.sheet_to_json(preguntasSheet, { defval: '' });
          const preguntasData = preguntasDataRaw.map((row) => this.transformExcelRow(row));

          const alternativasDataRaw = XLSX.utils.sheet_to_json(alternativasSheet, { defval: '' });
          const alternativasData = alternativasDataRaw.map((row) => this.transformExcelRow(row));

          this.excelData = preguntasData.map((pregunta, i) => {
            const np = this.numeroPreguntaValue(pregunta);
            const alternativas = alternativasData
              .filter((a) => String(this.numeroPreguntaValue(a)) === String(np))
              .sort((a, b) => {
                const na = parseInt(String(this.numeroAlternativaValue(a) || 0), 10) || 0;
                const nb = parseInt(String(this.numeroAlternativaValue(b) || 0), 10) || 0;
                return na - nb;
              });
            return {
              _rowUid: `simce-row-${i}-${String(np)}`,
              pregunta,
              alternativas,
              status: 'Pendiente',
              log: ''
            };
          });

          if (this.excelData.length === 0 || this.excelData.some((row) => row.alternativas.length === 0)) {
            alert(
              'Datos incompletos: cada fila de "preguntas" debe tener el mismo N° de pregunta que en "alternativas" (revisa Nº vs N° en ambas hojas).'
            );
            this.excelData = [];
          }
        } catch (error) {
          console.error('Error al procesar el archivo Excel:', error);
          alert('Error al procesar el archivo Excel: ' + error.message);
          this.excelData = [];
        }
      };
      reader.readAsArrayBuffer(file);
    },

    addRow(row) {
      if (!this.selectedRows.includes(row)) {
        this.selectedRows.push(row);
      }
    },

    removeRow(row) {
      this.selectedRows = this.selectedRows.filter(r => r !== row);
    },

    addAllRows() {
      this.selectedRows = this.excelData.filter(row => row.status !== 'Procesando' && row.status !== 'Éxito');
    },

    removeAllRows() {
      this.selectedRows = [];
    },

    isRowSelected(row) {
      return this.selectedRows.includes(row);
    },

    async guardarPreguntas() {
      if (!this.selectedRows.length) {
        alert('Por favor, selecciona al menos una pregunta para guardar.');
        return;
      }

      this.isProcessing = true;
      this.$store.dispatch('form/submit', true);
      const errores = [];

      try {
        if (!this.selectedUnidadId || this.selectedUnidadId === 0) {
          throw new Error('No se ha seleccionado una unidad válida para las preguntas.');
        }

        this.excelData = this.excelData.map(row => {
          if (this.selectedRows.includes(row)) {
            return { ...row, status: 'Procesando', log: `Procesando - ${new Date().toLocaleString()}` };
          }
          return row;
        });

        for (const row of this.selectedRows) {
          try {
            const alternativas = [...(row.alternativas || [])].sort((a, b) => {
              const na = parseInt(String(this.numeroAlternativaValue(a) || 0), 10) || 0;
              const nb = parseInt(String(this.numeroAlternativaValue(b) || 0), 10) || 0;
              return na - nb;
            });
            const np = this.numeroPreguntaValue(row.pregunta);
            const oaRaw = row.pregunta.OA;
            const oaNum = oaRaw !== undefined && oaRaw !== null && String(oaRaw).trim() !== ''
              ? Number(oaRaw)
              : NaN;
            // N° del Excel SIMCE NO es id_pregunta en BD: si se envía 1,2,3… en cada capítulo,
            // el SP hace UPDATE y reasigna id_video — las preguntas “desaparecen” del capítulo anterior.
            const payload = {
              IdPregunta: 0,
              Glosa: row.pregunta.PREGUNTA || row.pregunta['PREGUNTA'] || '',
              Vigente: true,
              GlosaSolucion: row.pregunta.SOLUCIÓN_DESCRIPTIVA || row.pregunta['SOLUCIÓN_DESCRIPTIVA'] || '',
              LinkImagenPregunta: this.normalizeLinkImagenRelativa(
                row.pregunta.IMAGEN_DE_PREGUNTA || row.pregunta['IMAGEN_DE_PREGUNTA'] || ''
              ),
              DescripcionImagen: this.descripcionImagenFromRow(row.pregunta),
              LinkImagenSolucion: '',
              IdAsignatura: this.selectedAsignatura[0],
              IdCurso: this.selectedCurso[0],
              IdHabilidad: this.mapHabilidad(this.textoHabilidadFromRow(row.pregunta)),
              IdDificultad: this.mapDificultad(this.textoDificultadFromRow(row.pregunta)),
              IdModalidad: 1,
              IdEjeTematico: this.selectedUnidadId,
              IdVideo: this.selectedVideo.IdVideo,
              UsuarioIdCreacion: this.user,
              FechaCreacion: new Date().toISOString(),
              FechaActualizacion: new Date().toISOString(),
              IdOA: Number.isFinite(oaNum) ? oaNum : null,
              ConSonido: null,
              UrlSonido: '',
              VerGlosaPregunta: null,
              GlosaAlter1: this.glosaAlternativa(alternativas[0]),
              CFAlter1: this.esAlternativaCorrecta(alternativas[0]),
              GlosaAlter2: this.glosaAlternativa(alternativas[1]),
              CFAlter2: this.esAlternativaCorrecta(alternativas[1]),
              GlosaAlter3: this.glosaAlternativa(alternativas[2]),
              CFAlter3: this.esAlternativaCorrecta(alternativas[2]),
              GlosaAlter4: this.glosaAlternativa(alternativas[3]),
              CFAlter4: this.esAlternativaCorrecta(alternativas[3])
            };

            if (!payload.Glosa || (!payload.CFAlter1 && !payload.CFAlter2 && !payload.CFAlter3 && !payload.CFAlter4)) {
              throw new Error('Faltan campos obligatorios (pregunta o al menos una alternativa correcta)');
            }
            if (payload.IdPregunta === 0 && (!payload.IdHabilidad || !payload.IdDificultad)) {
              const hTxt = this.textoHabilidadFromRow(row.pregunta);
              const dTxt = this.textoDificultadFromRow(row.pregunta);
              throw new Error(
                `Habilidad o dificultad no reconocidas en el Excel (habilidad: "${hTxt || 'vacío'}", dificultad: "${dTxt || 'vacío'}"). ` +
                  'La habilidad debe coincidir con el Mantenedor de habilidades o con etiquetas SIMCE (Reconocer, Interpretar, Inferir, Extraer información explícita, Discriminar, etc.). ' +
                  'Dificultad: Fácil, Intermedio o Difícil.'
              );
            }

            console.log('Enviando pregunta al backend:', payload);
            const response = await PreguntaService.saveSimceQuestion(payload).catch(err => {
              throw new Error(`Fallo en el servidor: ${err.message}`);
            });

            const idBdRaw = response?.IdPregunta ?? response?.idPregunta;
            const idBd =
              idBdRaw !== undefined && idBdRaw !== null && idBdRaw !== ''
                ? Number(idBdRaw)
                : null;
            const extra =
              idBd != null && !Number.isNaN(idBd) ? { idPreguntaBd: idBd } : {};

            const log = [
              `Pregunta SIMCE guardada exitosamente.`,
              `N° SIMCE (Excel): ${np}`,
              idBd != null && !Number.isNaN(idBd) ? `Id pregunta (BD): ${idBd}` : '',
              `Fecha: ${new Date().toLocaleString()}`,
              `Usuario: ${this.user}`,
              `ID video: ${this.selectedVideo.IdVideo}`,
              (response?.Message || response?.message) ? `Mensaje del servidor: ${response.Message || response.message}` : ''
            ].filter(Boolean).join('\n');

            this.updateRowStatus(row, 'Éxito', log, extra);
          } catch (error) {
            const errorMsg = error.response?.data?.message || error.message || 'Error desconocido al guardar la pregunta';
            console.error('Error al guardar pregunta:', errorMsg, error);
            errores.push({ ...row, error: errorMsg });
            const errorLog = [
              `Error al guardar la pregunta.`,
              `Mensaje: ${errorMsg}`,
              `Fecha: ${new Date().toLocaleString()}`,
              error.response?.status ? `Código HTTP: ${error.response.status}` : ''
            ].filter(Boolean).join('\n');
            this.updateRowStatus(row, `Error: ${errorMsg}`, errorLog);
          }
        }

        if (errores.length > 0) {
          console.warn('Se generaron errores durante el guardado:', errores);
          this.generarExcelErrores(errores);
          alert('Algunas preguntas no se pudieron guardar. Se ha generado un archivo con los errores.');
        } else {
          alert('Todas las preguntas seleccionadas fueron guardadas exitosamente.');
        }

        this.selectedRows = [];
      } catch (error) {
        console.error('Error crítico en el proceso de guardado:', error);
        alert('Error crítico al guardar las preguntas: ' + error.message);
        this.excelData = this.excelData.map(row => {
          if (row.status === 'Procesando') {
            return {
              ...row,
              status: 'Error: Proceso interrumpido',
              log: `${row.log}\nError crítico: ${error.message}\nFecha: ${new Date().toLocaleString()}`
            };
          }
          return row;
        });
      } finally {
        this.isProcessing = false;
        this.$store.dispatch('form/submit', false);
      }
    },

    updateRowStatus(row, status, log = '', extra = {}) {
      console.log('Actualizando estado de fila:', this.numeroPreguntaValue(row.pregunta), 'a', status);
      this.excelData = this.excelData.map(r => {
        if (r === row) {
          return { ...r, status, log: r.log + (r.log ? '\n' : '') + log, ...extra };
        }
        return r;
      });
    },

    async handleStatusClick(row) {
      if (row.status === 'Éxito') {
        console.log('Abriendo log para pregunta:', this.numeroPreguntaValue(row.pregunta));
        this.selectedQuestionLog = row;
        this.showLogModal = true;
      } else if (row.status === 'Procesando') {
        console.log('Verificando estado de pregunta:', this.numeroPreguntaValue(row.pregunta));
        await this.checkProcessingStatus(row);
      }
    },

    async checkProcessingStatus(row) {
      try {
        // Aquí simulamos una verificación con el backend. Ajusta según tu API.
        const payload = {
          IdPregunta: this.numeroPreguntaValue(row.pregunta),
          IdVideo: this.selectedVideo.IdVideo
        };
        console.log('Verificando estado en el backend:', payload);
        // Suponiendo que tienes un endpoint para verificar el estado
        const response = await PreguntaService.checkQuestionStatus(payload).catch(() => {
          throw new Error('No se pudo verificar el estado');
        });

        const status = response.data?.status || 'Error: Estado no disponible';
        const log = [
          `Estado verificado manualmente.`,
          `Nuevo estado: ${status}`,
          `Fecha: ${new Date().toLocaleString()}`,
          response.data?.message ? `Mensaje del servidor: ${response.data.message}` : ''
        ].filter(Boolean).join('\n');

        this.updateRowStatus(row, status, log);
      } catch (error) {
        const errorMsg = error.message || 'Error al verificar el estado';
        console.error('Error al verificar estado:', errorMsg);
        const errorLog = `Error al verificar: ${errorMsg}\nFecha: ${new Date().toLocaleString()}`;
        this.updateRowStatus(row, `Error: ${errorMsg}`, errorLog);
      }
    },

    generarExcelErrores(errores) {
      const headers = [...this.tableHeaders, 'Error'];
      const data = [headers, ...errores.map(row => [
        this.numeroPreguntaDisplay(row.pregunta),
        row.pregunta.PREGUNTA || row.pregunta['PREGUNTA'],
        row.alternativas.map(a => `${this.numeroAlternativaValue(a)}: ${this.glosaAlternativa(a)} (${this.esAlternativaCorrecta(a) ? 'Correcta' : 'Incorrecta'})`).join(', '),
        row.pregunta.GRADO_DE_DIFICULTAD || row.pregunta['GRADO_DE_DIFICULTAD'],
        row.pregunta.HABILIDAD || row.pregunta['HABILIDAD'],
        row.pregunta.UNIDAD || row.pregunta['UNIDAD'],
        row.pregunta.SOLUCIÓN_DESCRIPTIVA || row.pregunta['SOLUCIÓN_DESCRIPTIVA'],
        row.pregunta.IMAGEN_DE_PREGUNTA || row.pregunta['IMAGEN_DE_PREGUNTA'],
        this.descripcionImagenFromRow(row.pregunta),
        row.error
      ])];
      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Errores");
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Errores_Preguntas_SIMCE_${new Date().toISOString().split('T')[0]}.xlsx`;
      link.click();
      URL.revokeObjectURL(url);
    },

    getStatusClass(status) {
      if (status === 'Éxito') return 'status-success';
      if (status && status.startsWith('Error')) return 'status-error';
      if (status === 'Procesando') return 'status-processing';
      return 'status-pending';
    },

    textoHabilidadFromRow(pregunta) {
      if (!pregunta || typeof pregunta !== 'object') return '';
      for (const k of ['HABILIDAD', 'HABILIDAD_']) {
        const v = pregunta[k];
        if (v !== undefined && v !== null && String(v).trim() !== '') return String(v).trim();
      }
      const key = Object.keys(pregunta).find((k) => String(k).replace(/_+$/u, '').toUpperCase() === 'HABILIDAD');
      return key ? String(pregunta[key]).trim() : '';
    },

    textoDificultadFromRow(pregunta) {
      if (!pregunta || typeof pregunta !== 'object') return '';
      const prefer = ['GRADO_DE_DIFICULTAD', 'GRADO_DE_DIFICULTAD_'];
      for (const k of prefer) {
        const v = pregunta[k];
        if (v !== undefined && v !== null && String(v).trim() !== '') return String(v).trim();
      }
      const key = Object.keys(pregunta).find((k) => {
        const u = String(k).replace(/_+$/u, '').toUpperCase();
        return u.includes('DIFICULTAD') || u.includes('GRADO');
      });
      return key ? String(pregunta[key]).trim() : '';
    },

    normalizeHabilidadKey(raw) {
      return String(raw ?? '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    },

    async loadCatalogos() {
      await Promise.all([this.loadHabilidadesCatalog(), this.loadDificultadesCatalog()]);
    },
    async loadHabilidadesCatalog() {
      try {
        const r = await HabilidadService.listar({ todos: true });
        const list = Array.isArray(r.data) ? r.data : [];
        this.habilidadesCatalog = list;
        this.habilidadesById = buildIdGlosaMap(list);
        const byKey = {};
        for (const h of list) {
          const id = Number(h.Id ?? h.id);
          const glosa = h.Glosa ?? h.glosa ?? '';
          const key = this.normalizeHabilidadKey(glosa);
          if (key && Number.isFinite(id) && id > 0) {
            byKey[key] = id;
          }
        }
        this.habilidadesByKey = byKey;
      } catch (e) {
        console.warn('[SIMCE] No se pudo cargar el catálogo de habilidades:', e);
        this.habilidadesCatalog = [];
        this.habilidadesByKey = {};
        this.habilidadesById = {};
      }
    },
    async loadDificultadesCatalog() {
      try {
        const r = await DificultadService.listar({ vigente: true });
        this.dificultadesById = buildIdGlosaMap(r.data);
      } catch (e) {
        console.warn('[SIMCE] No se pudo cargar el catálogo de dificultades:', e);
        this.dificultadesById = {};
      }
    },
    habilidadExcelDisplay(pregunta) {
      const raw = this.textoHabilidadFromRow(pregunta);
      return resolveCatalogDisplay({
        glosa: raw,
        byId: this.habilidadesById,
        fallback: HABILIDAD_LABELS_FALLBACK,
      });
    },
    dificultadExcelDisplay(pregunta) {
      const raw = this.textoDificultadFromRow(pregunta);
      return resolveCatalogDisplay({
        glosa: raw,
        byId: this.dificultadesById,
        fallback: DIFICULTAD_LABELS_FALLBACK,
      });
    },

    staticHabilidadAliases() {
      return {
        aplicar: 1,
        comprender: 2,
        analizar: 3,
        recordar: 4,
        reconocer: 4,
        localizar: 2,
        interpretar: 2,
        inferir: 3,
        evaluar: 3,
        reflexionar: 3,
        discriminar: 3,
        'extraer informacion explicita': 2,
        'extraer informacion': 2,
        extraer: 2
      };
    },

    resolveHabilidadFromCatalogFuzzy(key) {
      if (!key || !this.habilidadesCatalog.length) return 0;
      let bestId = 0;
      let bestScore = 0;
      for (const h of this.habilidadesCatalog) {
        const id = Number(h.Id ?? h.id);
        const g = this.normalizeHabilidadKey(h.Glosa ?? h.glosa ?? '');
        if (!g || !Number.isFinite(id) || id <= 0) continue;
        if (g === key) return id;
        let score = 0;
        if (key.includes(g) || g.includes(key)) {
          score = Math.min(key.length, g.length);
        }
        if (score > bestScore) {
          bestScore = score;
          bestId = id;
        }
      }
      return bestId;
    },

    mapHabilidad(habilidad) {
      if (habilidad !== null && habilidad !== undefined && typeof habilidad === 'number' && Number.isFinite(habilidad)) {
        const n = Math.trunc(habilidad);
        return n > 0 ? n : 0;
      }
      const raw = String(habilidad ?? '').trim();
      if (!raw) return 0;
      if (/^\d+$/.test(raw)) {
        const asNum = parseInt(raw, 10);
        if (!Number.isNaN(asNum) && asNum > 0) return asNum;
      }
      const key = this.normalizeHabilidadKey(raw);
      if (!key) return 0;

      if (this.habilidadesByKey[key] !== undefined) {
        return this.habilidadesByKey[key];
      }

      const aliases = this.staticHabilidadAliases();
      if (aliases[key] !== undefined) return aliases[key];
      const first = key.split(/[\s,;]+/)[0];
      if (aliases[first] !== undefined) return aliases[first];

      const fuzzy = this.resolveHabilidadFromCatalogFuzzy(key);
      if (fuzzy > 0) return fuzzy;

      return 0;
    },

    mapDificultad(dificultad) {
      if (dificultad !== null && dificultad !== undefined && typeof dificultad === 'number' && Number.isFinite(dificultad)) {
        const n = Math.trunc(dificultad);
        return n >= 1 && n <= 3 ? n : 0;
      }
      const raw = String(dificultad ?? '').trim();
      if (!raw) return 0;
      if (/^\d+$/.test(raw)) {
        const asNum = parseInt(raw, 10);
        if (!Number.isNaN(asNum) && asNum >= 1 && asNum <= 3) return asNum;
      }
      const key = raw
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
      const map = {
        facil: 1,
        'muy facil': 1,
        intermedio: 2,
        medio: 2,
        dificil: 3
      };
      if (map[key] !== undefined) return map[key];
      const first = key.split(/[\s,;]+/)[0];
      if (map[first] !== undefined) return map[first];
      return 0;
    },

    /** Columna M del Excel SIMCE: encabezado "TEXTO" → clave TEXTO tras normalizar. */
    descripcionImagenFromRow(pregunta) {
      if (!pregunta || typeof pregunta !== 'object') return '';
      const texto = pregunta.TEXTO;
      if (texto !== undefined && texto !== null && String(texto).trim() !== '') {
        return String(texto).trim();
      }
      const leg = pregunta.DESCRIPCIÓN_DE_LA_IMAGEN ?? pregunta.DESCRIPCION_DE_LA_IMAGEN;
      if (leg !== undefined && leg !== null && String(leg).trim() !== '') {
        return String(leg).trim();
      }
      return '';
    },

    /** Número de alternativa (1–4) según encabezados típicos del Excel SIMCE. */
    numeroAlternativaValue(obj) {
      if (!obj || typeof obj !== 'object') return '';
      const prefer = ['NÚMERO_ALTERNATIVA', 'NUMERO_ALTERNATIVA', 'Nº_ALTERNATIVA', 'N°_ALTERNATIVA'];
      for (const k of prefer) {
        const v = obj[k];
        if (v !== undefined && v !== null && String(v).trim() !== '') return v;
      }
      for (const key of Object.keys(obj)) {
        const u = String(key).toUpperCase();
        if (u.includes('ALTERNATIVA') && (u.includes('NÚMERO') || u.includes('NUMERO') || u.includes('Nº') || u.includes('N°'))) {
          const v = obj[key];
          if (v !== undefined && v !== null && String(v).trim() !== '') return v;
        }
      }
      return '';
    },

    glosaAlternativa(alt) {
      if (!alt || typeof alt !== 'object') return '';
      for (const k of ['GLOSA', 'GLOSA_']) {
        const v = alt[k];
        if (v !== undefined && v !== null && String(v).trim() !== '') return String(v).trim();
      }
      const key = Object.keys(alt).find((k) => String(k).replace(/_+$/u, '').toUpperCase() === 'GLOSA');
      return key ? String(alt[key]).trim() : '';
    },

    esAlternativaCorrecta(alt) {
      if (!alt) return false;
      const c = alt.CORRECTA !== undefined && alt.CORRECTA !== null ? alt.CORRECTA : alt.CORRECTA_;
      if (c === 1 || c === true || c === '1' || String(c).toLowerCase() === 'true') return true;
      return false;
    },

    onMatrixSimceOk(msg) {
      if (msg) console.log('[SIMCE matrices]', msg);
    },

    onMatrixSimceErr(msg) {
      alert(typeof msg === 'string' ? msg : 'Error al generar matrices SIMCE.');
    },

    openExcelUploadImageModal(row) {
      this.excelUploadRow = row;
      this.showExcelUploadImageModal = true;
    },

    closeExcelUploadImageModal() {
      this.showExcelUploadImageModal = false;
      this.excelUploadRow = null;
    },

    onExcelUploadImageUploaded() {
      this.closeExcelUploadImageModal();
      alert('Imagen subida correctamente. La ruta quedó guardada en la pregunta.');
    },

    /** Mismo criterio que SubirImagen / MantenedorVideos (formatApiError). */
    onSimceImageUploadError(msg) {
      const m =
        typeof msg === 'string' && msg.trim()
          ? msg
          : `Error al subir la imagen de la pregunta.`;
      alert(m);
    },

    mapUnidad(unidad) {
      if (!this.subject || !Array.isArray(this.subject.Capitulos)) {
        console.error('this.subject o Capitulos no están definidos');
        return 0;
      }

      const unidadNormalizada = unidad.replace('Unit', 'Unidad');
      const capituloEncontrado = this.subject.Capitulos.find(c => c.UnidadGrupo === unidadNormalizada);

      if (!capituloEncontrado) {
        console.error('No se encontró un capítulo con UnidadGrupo igual a', unidadNormalizada);
        return 0;
      }

      return capituloEncontrado.UnidadId || 0;
    },

    /**
     * Misma forma relativa que IngresoPreguntas2 / backend: `resources/v2_upload/...`
     * Si el Excel trae URL absoluta, se reduce a la ruta bajo `resources/`.
     */
    normalizeLinkImagenRelativa(raw) {
      if (raw == null || String(raw).trim() === '') return '';
      let s = String(raw).trim();
      if (/^resources\//i.test(s)) return s.replace(/^\/+/, '');
      try {
        if (/^https?:\/\//i.test(s)) {
          const u = new URL(s);
          const p = u.pathname.replace(/^\/+/, '');
          const idx = p.toLowerCase().indexOf('resources/');
          if (idx >= 0) return p.slice(idx);
        }
      } catch (_) {
        /* URL inválida: se devuelve el texto */
      }
      return s;
    },
  },
  created() {
    this.loadCatalogos();
    if (this.$route.params.curso_id && this.$route.params.asignatura_id) {
      console.log('Inicializando con parámetros de ruta:', this.$route.params);
      this.selectedCurso = [this.$route.params.curso_id];
      this.selectedAsignatura = [this.$route.params.asignatura_id];
      this.getChapters(this.selectedCurso[0], this.selectedAsignatura[0]);
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      token: 'auth/access-token',
      current_capitulo: 'toolbar/title'
    })
  }
};
</script>

<style scoped>
.is-background { z-index: 1; }
.columns-horizontal-scroll { 
  display: flex; 
  overflow-x: auto; 
  white-space: nowrap; 
  padding: 10px 0; 
}
.columns-horizontal-scroll .column,
.simce-chapter-scroll .column {
  display: inline-block;
  margin-right: 15px;
}
.simce-chapter-scroll .column,
.simce-video-carousel .column {
  flex: 0 0 auto;
}
.text-glow { 
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.9), 0 0 20px rgba(255, 255, 255, 0.8), 0 0 30px rgba(255, 255, 255, 0.7), 0 0 40px rgba(255, 255, 255, 0.6), 0 0 50px rgba(255, 255, 255, 0.5); 
}
.unit-border { 
  border: 0.1px solid #c0c0c0 !important; 
  border-radius: 8px !important; 
  padding: 16px; 
  margin-bottom: 12px !important; 
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important; 
  z-index: 30 !important; 
}

.video-carousel {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 15px;
  padding: 10px 0;
}

.video-card-column {
  flex: 0 0 auto;
  min-width: 200px;
  max-width: 250px;
}

.video-card {
  border: 2px solid #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.video-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.upload-section .file-label {
  background-color: #f5f5f5;
  border: 2px dashed #ccc;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.upload-section .file-label:hover {
  background-color: #e9ecef;
  border-color: #2196f3;
}

.file-input {
  display: none;
}

.table-container {
  width: 100%;
}

.status-success {
  color: #28a745;
  font-weight: 600;
}

.status-success:hover {
  text-decoration: underline;
}

.status-error {
  color: #dc3545;
  font-weight: 600;
}

.status-processing {
  color: #ffc107;
  font-weight: 600;
}

.status-processing .pi-spinner,
.status-success .pi-check,
.status-error .pi-times {
  font-size: 1rem;
  vertical-align: middle;
}

.status-pending {
  color: #6c757d;
}

.p-button-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.simce-page {
  padding-bottom: 2rem;
}

.simce-filters.box {
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e8e8e8;
  margin-bottom: 1.25rem;
}

.simce-page-title {
  font-size: 1.35rem;
  font-weight: 700;
  margin-bottom: 0.35rem;
  color: #363636;
}

.simce-page-subtitle {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 1rem;
}

.simce-toolbar-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0.5rem 0;
}

.simce-unit-wrap {
  margin-bottom: 1.25rem;
}

.simce-unit-card {
  background: #fafafa;
}

.simce-unit-header {
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e0e0e0;
}

.simce-unit-meta {
  font-size: 0.8rem;
  color: #7a7a7a;
  margin: 0;
}

.simce-grupo-block {
  margin-top: 1rem;
}

.simce-grupo-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
}

.simce-grupo-tag {
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-weight: 700;
  color: #fff;
  background: #7a7a7a;
  padding: 0.2rem 0.45rem;
  border-radius: 4px;
}

.simce-grupo-name {
  font-weight: 600;
  color: #4a4a4a;
  font-size: 0.95rem;
}

.simce-chapter-card {
  display: inline-block;
  vertical-align: top;
  min-width: 280px;
  max-width: 340px;
  margin-right: 12px;
  margin-bottom: 8px;
  padding: 0.75rem 0.85rem 1rem;
}

.simce-chapter-head {
  margin-bottom: 0.65rem;
}

.simce-badge-orden {
  display: inline-block;
  font-size: 0.65rem;
  font-weight: 700;
  color: #0d47a1;
  background: #e3f2fd;
  padding: 0.15rem 0.4rem;
  border-radius: 4px;
  margin-right: 0.35rem;
  vertical-align: middle;
}

.simce-id-chip {
  display: inline-block;
  font-family: ui-monospace, monospace;
  font-size: 0.7rem;
  color: #555;
  background: #eee;
  padding: 0.1rem 0.35rem;
  border-radius: 3px;
  vertical-align: middle;
}

.simce-chapter-glosa {
  font-size: 0.85rem;
  font-weight: 600;
  color: #333;
  margin: 0.4rem 0 0 0;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.simce-video-tile {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.simce-video-meta {
  font-size: 0.72rem;
  color: #666;
  line-height: 1.3;
  font-family: ui-monospace, monospace;
}

.simce-meta-sep {
  margin: 0 0.2rem;
  color: #bbb;
}

.simce-video-title {
  font-size: 0.8rem;
  font-weight: 600;
  color: #333;
  margin: 0.35rem 0 0;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 2.2em;
}

.simce-video-actions {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.simce-video-actions :deep(.p-button) {
  width: 100%;
  justify-content: center;
}

.simce-upload-img-dialog {
  padding: 0.25rem 0;
}

.simce-upload-img-hint {
  font-size: 0.85rem;
  line-height: 1.45;
  color: #363636;
  margin: 0 0 0.75rem;
}

.simce-upload-img-hint.is-muted {
  color: #666;
  font-size: 0.8rem;
}

.simce-upload-hint {
  display: block;
  max-width: 42rem;
  margin: 0 auto;
  font-size: 0.88rem;
  line-height: 1.45;
  color: #444;
}

.simce-cell-texto {
  font-size: 0.85rem;
  color: #333;
  white-space: pre-wrap;
  word-break: break-word;
}

.w-full {
  width: 100%;
}
</style>